export const UPDATE_EVENT_METADATA = 'UPDATE_EVENT_METADATA';

export const updateEventMetadata = eventMetadata => ({
	type: UPDATE_EVENT_METADATA,
	eventMetadata,
});
